import React from 'react';
import {
    Typography,
    Accordion,
    AccordionSummary,
    Button,
    Card,
    Box,
    useMediaQuery,
    LinearProgress
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import OrderDetails from './OrderDetails';
import translations from '../translations/ordersToConfirmTranalation';

const OrdersToConfirm = ({ salesPromotions, onApprove, onReject, product_columns, columns, loadingStates }) => {
    const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('md'));

    if (!salesPromotions.length)
        return (
            <Box sx={{ p: 3 }} direction="rtl" textAlign={'left'}>
                <p>{translations.no_pending_orders}</p>
            </Box>
        )

    return (
        <Box sx={{ p: isDesktop ? 3 : 2 }} direction="rtl">
            <Typography
                variant="h1"
                gutterBottom
                sx={{ color: "#0563B0", fontSize: "1.5rem", margin: '10px' }}

            >
                {translations.ordersAwaitingYourApproval}
            </Typography>
            {salesPromotions.map((sp, index) => (
                <Card
                    key={index}
                    sx={{
                        mb: isDesktop ? 3 : 2,
                        borderRadius: isDesktop ? 4 : 2,
                        overflow: 'hidden',
                        transition: 'all 0.3s ease',
                        boxShadow: isDesktop
                            ? '0 3px 5px 2px rgba(0, 0, 0, 0.1)'
                            : '0 2px 4px rgba(0, 0, 0, 0.1)',
                        '&:hover': isDesktop ? {
                            transform: 'translateY(-5px)',
                            boxShadow: '0 5px 8px 3px rgba(0, 0, 0, 0.2)',
                        } : {},
                        maxWidth: isDesktop ? '80%' : '100%',
                        mx: isDesktop ? 'auto' : 0,
                    }}
                >
                    {loadingStates[sp._id] && <LinearProgress />}
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: '#757575' }} />}
                            aria-controls={`panel${index}a-content`}
                            id={`panel${index}a-header`}
                        >
                            {isDesktop ? (
                                <>
                                    <Typography sx={{ width: '33%', flexShrink: 0, fontWeight: 'bold' }}>
                                        {sp.ordName}
                                    </Typography>
                                    <Typography sx={{ color: 'text.secondary', flexGrow: 1 }}>
                                        {sp.createdAt.split("T")[0]}
                                    </Typography>
                                </>
                            ) : (
                                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>
                                        {sp.ordName}
                                    </Typography>
                                    <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                                        {sp.createdAt.split("T")[0]}
                                    </Typography>
                                </Box>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<ThumbUpAltIcon />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onApprove(sp._id);
                                }}
                                sx={{
                                    mr: 2,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                    '&:hover': {
                                        boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                                    },
                                }}
                            >
                                {translations.approve_order}
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onReject(sp._id);
                                }}
                                sx={{
                                    minWidth: 'auto',
                                    mr: 1,
                                    boxShadow: '0 1px 1px rgba(0,0,0,0.2)',
                                    '&:hover': {
                                        boxShadow: '0 1px 1px rgba(0,0,0,0.3)',
                                    },
                                }}
                            >
                                {translations.cancel_order}
                            </Button>
                        </AccordionSummary>
                        <OrderDetails sp={sp} product_columns={product_columns} columns={columns} />
                    </Accordion>
                </Card>
            ))}
        </Box>
    );
};

export default OrdersToConfirm;